import { Vector2 } from './math'

export function viewport(): Vector2 {
  if (typeof window === 'undefined') return [0, 0]
  const { clientWidth, clientHeight } = window.document.documentElement
  // return mul2([clientWidth, clientHeight], window.devicePixelRatio)
  return [clientWidth, clientHeight]
}
